import axios from '../../../../helpers/custom-axios';
import { notify, confirmation } from '../../../../helpers/notifications';
import { generate_uuidv4 } from '../../../../helpers/generate-uuid';

export const beginExport = (params) => {
  const config = 'popup,left=600,top=400,width=740,height=460';
  window.open(`/manage/submissions/export?${params}`, '_blank', config);
};

export const generateParams = (formID, filters, includeParent, fields) => {
  let uuid = generate_uuidv4();
  let format = { filters: filters, parent_sub: includeParent };
  if (fields) {
    format.fields = fields;
  }
  let params = {
    form_id: formID,
    export_uuid: uuid,
    format: JSON.stringify({
      ...format,
    }),
  };
  let urlParams = new URLSearchParams(params).toString();
  return urlParams;
};

export const createExport = async (formID, name, fields) => {
  let newExport = { form_id: formID, name, fields };
  return axios
    .post(`/manage/exports`, newExport)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyExport = async (exportID, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/exports/${exportID}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};
